import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControlLabel,
  Switch,
  TextField,
  Typography,
  Box,
  IconButton,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
} from "@material-ui/core";
import { Add as AddIcon, Delete as DeleteIcon } from "@material-ui/icons";

const ModalPropuestaConfig = ({ open, onClose, onGenerate, nombreCliente }) => {
  const [incluirEntregables, setIncluirEntregables] = useState(false);
  const [incluirConsideraciones, setIncluirConsideraciones] = useState(false);
  const [entregables, setEntregables] = useState([]);
  const [nuevoEntregable, setNuevoEntregable] = useState("");

  useEffect(() => {
    if (open) {
      resetValues();
    }
  }, [open]);

  const handleAgregarEntregable = () => {
    if (nuevoEntregable.trim()) {
      setEntregables([...entregables, nuevoEntregable.trim()]);
      setNuevoEntregable("");
    }
  };

  const handleEliminarEntregable = (index) => {
    setEntregables(entregables.filter((_, i) => i !== index));
  };

  const resetValues = () => {
    setIncluirEntregables(false);
    setIncluirConsideraciones(false);
    setEntregables([]);
    setNuevoEntregable("");
  };

  const handleGenerar = () => {
    const config = {
      incluirEntregables,
      incluirConsideraciones,
      entregables: incluirEntregables ? entregables : [],
    };
    onGenerate(config);
    resetValues();
    onClose();
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleAgregarEntregable();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        style: { minHeight: "500px" },
      }}
    >
      <DialogTitle>Configurar Propuesta - {nombreCliente}</DialogTitle>

      <DialogContent>
        <Box mb={3}>
          <Typography variant="h6" gutterBottom>
            Secciones a incluir:
          </Typography>

          <FormControlLabel
            control={
              <Switch
                checked={incluirConsideraciones}
                onChange={(e) => setIncluirConsideraciones(e.target.checked)}
                color="primary"
              />
            }
            label="Incluir sección de Consideraciones"
          />

          <FormControlLabel
            control={
              <Switch
                checked={incluirEntregables}
                onChange={(e) => {
                  setEntregables([]);
                  setIncluirEntregables(e.target.checked);
                }}
                color="primary"
              />
            }
            label="Incluir sección de Entregables"
          />
        </Box>

        {incluirEntregables && (
          <Box>
            <Typography variant="h6" gutterBottom>
              Entregables del servicio:
            </Typography>

            <Box display="flex" alignItems="center" mb={2}>
              <TextField
                fullWidth
                variant="outlined"
                size="small"
                placeholder="Agregar nuevo entregable..."
                value={nuevoEntregable}
                onChange={(e) => setNuevoEntregable(e.target.value)}
                onKeyPress={handleKeyPress}
              />
              <IconButton
                color="primary"
                onClick={handleAgregarEntregable}
                disabled={!nuevoEntregable.trim()}
              >
                <AddIcon />
              </IconButton>
            </Box>

            {entregables.length > 0 && (
              <List dense>
                {entregables.map((entregable, index) => (
                  <ListItem key={index} divider>
                    <ListItemText primary={`${index + 1}. ${entregable}`} />
                    <ListItemSecondaryAction>
                      <IconButton
                        edge="end"
                        onClick={() => handleEliminarEntregable(index)}
                        size="small"
                      >
                        <DeleteIcon />
                      </IconButton>
                    </ListItemSecondaryAction>
                  </ListItem>
                ))}
              </List>
            )}

            {entregables.length === 0 && (
              <Typography
                variant="body2"
                color="textSecondary"
                style={{ fontStyle: "italic" }}
              >
                No hay entregables agregados
              </Typography>
            )}
          </Box>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button onClick={handleGenerar} color="primary" variant="contained">
          Generar Propuesta
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalPropuestaConfig;
